module.exports = __webpack_public_path__ + "static/media/JohnsonBaby-Bold.ef3affd4.woff2";